import React, {useState} from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {useDispatch} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import DotsLoading from '../../../components/dotsLoading';
import BuyerCard from '../../../components/mazraeKit/cards/buyerCard';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import useGetRequirementView from '../../../services/hookService/my-account/getRequirementView/useGetRequirementView';
import useGetWantedPromotedRequirement from '../../../services/hookService/my-account/getWantedPromotedRequirement/useGetWantedPromotedRequirement';
import usePatchUserPromotedRequirement from '../../../services/hookService/my-account/patchUserPromotedRequirement/usePatchUserPromotedRequirement';
import CountDown from '../advertismentDetail/countDown';
import ExpireNotification from '../advertismentDetail/expireNotification';

import Alert from '../../../components/mazraeKit/alert';
import useDeleteMyAdvertisment from '../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';
import {
  resetAllAdvertisementData,
  resetFormData,
  resetOptionalFormData,
  resetRegisterAdvertisement,
} from '../../../store/redux/advertisementRegisteration';
import {descriptionHelper} from '../advertismentDetail/helper';
interface DeleteBotoomSheetData {
  guid: string;
  title: string;
}
export interface DeleteBotoomSheet {
  isOpen: boolean;
  data: null | DeleteBotoomSheetData;
}

export interface ILocationState {
  type: 'advertisement' | 'requirement';
  requirement_type: string;
}

const RequirementDetail = () => {
  const {guid, requirement_type} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });

  const {RequirementViewData, RequirementViewIsLoading} = useGetRequirementView(
    {guid, requirement_type: requirement_type || ''},
  );
  const {
    GetWantedPromotedRequirementData,
    GetWantedPromotedRequirementIsLoading,
    refetch,
  } = useGetWantedPromotedRequirement({guid});
  const {PatchUserPromotedRequirementMutate} = usePatchUserPromotedRequirement({
    onSuccess() {
      refetch();
    },
  });

  const {mutate} = useDeleteMyAdvertisment({
    filter: 'requirement',
    refetch: () => {
      setDeleteItem({isOpen: false, data: null});
      navigate('/my-ads');
    },
  });
  const manageList = [
    {
      className: '',
      icon: 'icon-nameEdit',
      label: 'ویرایش آگهی',
      action: () => {
        navigate(`/edit/advertisment/${guid}/${requirement_type}`, {
          state: {type: 'requirement'},
        });
        dispatch(resetRegisterAdvertisement({}));
        dispatch(resetAllAdvertisementData());
        dispatch(resetOptionalFormData(''));
        dispatch(resetFormData(''));
      },
    },
    {
      className: 'text-red-500',
      icon: 'icon-nameDelete',
      label: 'حذف آگهی',
      action: () => {
        setDeleteItem({
          isOpen: true,
          data: {guid: guid || '', title: RequirementViewData?.title || ''},
        });
      },
    },
  ];

  return (
    <div className="flex flex-col justify-between w-full h-full">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title={`مدیریت آکهی `}
        isActiveRightIcon={true}
        onClick={() => navigate(-1)}
      />

      <div className="flex-col w-full h-full gap-3 px-3 pb-3 overflow-y-scroll d-flex">
        <div className="pt-3">
          {RequirementViewIsLoading ? (
            <DotsLoading />
          ) : (
            <BuyerCard
              isActiveMessage={false}
              cardWrapperClassName="w-full"
              message={RequirementViewData?.title || ''}
              city={RequirementViewData?.city?.name || ''}
              state={RequirementViewData?.state?.name || ''}
              time={RequirementViewData?.published_at}
              phone={RequirementViewData?.hide_phone_number}
            />
          )}
        </div>
        {GetWantedPromotedRequirementIsLoading ? (
          <DotsLoading />
        ) : (
          <>
            {GetWantedPromotedRequirementData &&
              RequirementViewData?.title &&
              GetWantedPromotedRequirementData?.length > 0 &&
              GetWantedPromotedRequirementData.filter(
                item => !item.promote.expirable,
              ).map(item => (
                <Alert
                  key={item.guid}
                  colorPallete={{
                    borderColor: 'border-green-500',
                    backgroundColor: 'bg-green-50',
                    iconColor: 'text-green-600',
                  }}
                  description={
                    descriptionHelper(
                      item.promote.title,
                      // cardData?.title,
                      RequirementViewData?.title,
                      item,
                    ) || ''
                  }
                  icon="icon-nameCheck-circle"
                  label={item.promote.title}
                  closeAction={() =>
                    PatchUserPromotedRequirementMutate(item.guid)
                  }
                />
              ))}
            {GetWantedPromotedRequirementData &&
              GetWantedPromotedRequirementData?.length > 0 &&
              GetWantedPromotedRequirementData.filter(
                item =>
                  !item.promote.has_discount &&
                  item.promote.expirable &&
                  item.is_expired,
              ).length > 0 && (
                <ExpireNotification
                  type="advertisement"
                  expireList={GetWantedPromotedRequirementData.filter(
                    item =>
                      !item.promote.has_discount && item.promote.expirable,
                  ).map(item => {
                    return {
                      label: item.promote.title,
                      guid: item.promote.guid,
                    };
                  })}
                />
              )}
            {GetWantedPromotedRequirementData &&
              GetWantedPromotedRequirementData?.length > 0 &&
              GetWantedPromotedRequirementData.filter(
                item => !item.is_expired && item.promote.expirable,
              ).map(item => (
                <CountDown
                  key={item.guid}
                  dateTime={item.expire_date}
                  label={item.promote.title}
                  description="زمان باقی‌مانده برای آگهی منتشر شده با برچسب فوری:"
                />
              ))}
          </>
        )}

        <div className="flex flex-col w-full">
          {manageList.map((item, index) => (
            <React.Fragment key={index}>
              <div className="d-flex h-[56px] w-full justify-between items-center px-2 no-underline	text-inherit">
                <div
                  className={classNames(
                    'text-md text-gray-900 gap-2 flex items-center font-Regular',
                    item.className,
                  )}
                >
                  <SpanIcon className={classNames('text-xl', item.icon)} />
                  <div>{item.label}</div>
                </div>
                <button
                  aria-label={item.label}
                  onClick={() => item.action && item.action()}
                >
                  <SpanIcon
                    className={classNames('icon-nameArrow---Left-2 text-xxl', {
                      [item.className]: 'icon-nameDelete' === item.icon,
                    })}
                  />
                </button>
              </div>
              <div className="border-[1px] border-gray-200 flex w-full h-[1px]" />
            </React.Fragment>
          ))}
        </div>
        <BottomSheet
          onDismiss={() => {
            setDeleteItem({isOpen: false, data: null});
          }}
          open={deleteItem.isOpen}
          blocking={true}
          className="transition ease-in-out delay-250 "
        >
          <div className="flex flex-col w-full gap-2 p-3">
            <div className="flex justify-between w-full">
              <p className="text-md font-Regular">حذف آگهی</p>
              <SpanIcon
                className="text-xl icon-nameClose-remove"
                onClick={() => setDeleteItem({isOpen: false, data: null})}
              />
            </div>
            <p className="text-sm font-Regular">
              آیا اطمینان به حذف آگهی
              <span className="text-md font-DemiBold">
                {deleteItem.data?.title}
              </span>
              دارید؟
            </p>
            <div className="flex items-center justify-between w-full gap-2 text-md font-Medium">
              <button
                className="w-[70%] bg-red-500 h-[48px] text-white text-md rounded-[8px] font-Medium"
                onClick={() =>
                  deleteItem.data?.guid && mutate(deleteItem.data?.guid)
                }
              >
                بله، حذف
              </button>
              <button
                className="w-[30%] text-farm-shop-500 h-[48px] text-md font-Medium border border-farm-shop-500 rounded-[8px]"
                onClick={() => setDeleteItem({isOpen: false, data: null})}
              >
                خیر
              </button>
            </div>
          </div>
        </BottomSheet>
      </div>
      <MainFooter />
    </div>
  );
};

export default RequirementDetail;
